import { render, staticRenderFns } from "./CreatePostManagePhoto.vue?vue&type=template&id=1dd9489c&"
import script from "./CreatePostManagePhoto.vue?vue&type=script&lang=js&"
export * from "./CreatePostManagePhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports